import { useQuery } from "@tanstack/react-query";

import useApiHelper from "../hooks/useApiHelper";
import { ISingleQuoteLocationResponse } from "../models/Lead";
import apiConfig from "../utils/apiConfig";

export default function useQuoteLocation(
  leadId: string,
  enabled = true,
  componentName = "useQuoteLocation"
) {
  const { get } = useApiHelper(apiConfig(componentName));

  const quoteLocation = useQuery({
    queryKey: ["quoteLocation", leadId],
    queryFn: () => get<ISingleQuoteLocationResponse>(`/lead/${leadId}/quote-location`),
    staleTime: 1000 * 60 * 10, // 10 minutes
    enabled: enabled && Boolean(leadId),
  });

  return {
    quoteLocation,
  };
}
